import script from "./goRinSyo0022.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0022.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0022.vue?vue&type=style&index=0&id=573a793c&lang=scss"

const __exports__ = script;

export default __exports__